module.exports = "/_next/static/images/87dec64532e3eccfe10628365498e2ed-product-information-md-1x.jpg.webp";